import React, {useState} from "react";
import {Button, Card, Space} from "antd";
import {MarkdownTextarea} from "../../../core/markdown/markdown-textarea/markdown-textarea";
import {useTranslation} from "react-i18next";

interface TaskCommentProps {
    onSubmit: (value: string) => Promise<any>;
}

export const TaskNewComment: React.FC<TaskCommentProps> = ({onSubmit}) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [value, setValue] = useState<string>("");
    const {t} = useTranslation("translation", {useSuspense: false});

    const onCompleted = async () => {
        setLoading(true);
        try {
            await onSubmit(value);
            setValue("")
        } finally {
            setLoading(false);
        }
    }

    return (
        <Card
            title={"New comment"}
            size={"small"}
        >
            <Space direction={"vertical"} size={[20, 20]}>
                <MarkdownTextarea
                    value={value}
                    onChange={v => setValue(v)}
                    fileUploader={f => Promise.resolve<[string, string]>(["x", "x"])}
                    height={"100px"}
                    disabled={loading}
                />
                <Button
                    onClick={() => onCompleted()}
                    disabled={value.length === 0}
                    loading={loading}
                >
                    {t('SUBMIT')}
                </Button>
            </Space>
        </Card>
    )
}